// extracted by mini-css-extract-plugin
export default {"check-box":"CheckBox_check-box__LYQMb"};